import React from 'react';
import { useSpecSheetField } from '../../../../../queries/useSpecSheetField';
import { TextBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';

interface ShelvingProps {
    readOnly?: boolean;
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Shelving: React.FC<ShelvingProps> = ({ required, readOnly, propertyGuid, isReview = false }) => {
    const [shelving, setShelving] = useSpecSheetField(
        propertyGuid,
        (s) => s.values?.['Interior Features']?.['Shelving'] ?? '',
        (s, v) => ({ ...s, values: { ...s.values, 'Interior Features': { ...s.values?.['Interior Features'], Shelving: v } } })
    );
    const label = 'Shelving';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={shelving}
                />
            ) : (
                <TextBox
                    value={shelving ?? ''}
                    onChange={(value) => setShelving(value)}
                    label={label}
                    required={required}
                    readOnly={readOnly}
                />
            )}
        </>
    );
};
